import swaggerClient from "../remote-client";

export default class ExternalServiceImpl {
  /**
   * Retrieve the SiSalute service URL for the given functionality
   * @param {*} payload
   */
  callGetSiSaluteServiceURL(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient
        .then(client => {
          return client.apis.Appointment.getUrlSSOSiSaluteWithFunction(
            payload,
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(result => {
          let url = null;
          if (result.body?.urlToSalute) {
            url = result.body.urlToSalute;
          }
          resolve(url);
        })
        .catch(error => reject(error));
    });
  }

  /**
   * Retrieve the UniSalute service URL for the given functionality
   * @param {*} payload
   */
  callGetUniSaluteServiceURL(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient
        .then(client => {
          return client.apis.Appointment.getUrlSSOUniSaluteWithFunction(
            payload,
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(result => {
          let url = null;
          if (result.body?.urlToUniSalute) {
            url = result.body.urlToUniSalute;
          }
          resolve(url);
        })
        .catch(error => reject(error));
    });
  }

  /**
   * Retrieve the MyFondoEst service URL for the given functionality
   * @param {*} payload
   */
  callGetMyFondoEstServiceURL(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient
        .then(client => {
          return client.apis.Appointment.getUrlSSOMyFondoEstWithFunction(
            payload,
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(result => {
          let url = null;
          if (result.body?.urlToMyFondoEst) {
            url = result.body.urlToMyFondoEst;
          }
          resolve(url);
        })
        .catch(error => reject(error));
    });
  }

  /**
   * Retrieve the Mutual Help service URL for the given functionality
   * @param {*} payload
   */
  callGetMutualHelpServiceURL(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient
        .then(client => {
          return client.apis.Appointment.getUrlSSOPortaleWithMemberFiscalCodeWithFunction(
            payload,
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(result => {
          let url = null;
          if (result.body?.urlToPortal) {
            url = result.body.urlToPortal;
          }
          resolve(url);
        })
        .catch(error => reject(error));
    });
  }
}
